/**
 * X6 概念验证的硬编码演示数据。
 * 表示一个 OPM 示例模型："汽车制造"
 *
 * 结构：
 * - Car（对象）→ 包含状态：Assembled、Unassembled
 *               → 包含值：VIN-1001
 * - Engine（对象）→ 包含状态：Installed
 * - Assemble 过程：消耗 Engine，生成 Car(Assembled)
 * - Install 过程：使 Engine 变为 Installed 状态
 */

export const demoNodes = [
  {
    id: 'obj-car',
    shape: 'opm-object',
    x: 1165.1960784313728,
    y: 628.186274509804,
    width: 257.37060546875,
    height: 142,
    parentId: null,
    data: {
      label: 'Car',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 2,
      selected: false,
    },
  },
  {
    id: 'obj-parts-inventory',
    shape: 'opm-object',
    x: -151.76470588235298,
    y: -208.23529411764707,
    width: 240,
    height: 110,
    parentId: null,
    data: {
      label: 'Parts Inventory',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'obj-engine',
    shape: 'opm-object',
    x: 58.23529411764706,
    y: 632.9411764705883,
    width: 240.12255859375,
    height: 142,
    parentId: null,
    data: {
      label: 'Engine',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 2,
      selectionMode: 'single',
      selected: false,
    },
  },
  {
    id: 'obj-worker',
    shape: 'opm-object',
    x: 481.2254901960785,
    y: 678.5294117647059,
    width: 180,
    height: 90,
    parentId: null,
    data: {
      label: 'Worker',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
      dragTarget: false,
    },
  },
  {
    id: 'obj-blueprint',
    shape: 'opm-object',
    x: 826.813725490196,
    y: 683.235294117647,
    width: 200,
    height: 80,
    parentId: null,
    data: {
      label: 'Assembly Blueprint',
      type: 'object',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'state-unassembled',
    shape: 'opm-state',
    x: 1189.1960784313728,
    y: 694.1862745098036,
    width: 98.93994140625,
    height: 60,
    parentId: 'obj-car',
    data: {
      label: 'Unassembled',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-car',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'state-assembled',
    shape: 'opm-state',
    x: 1312.1360198376228,
    y: 694.1862745098036,
    width: 86.4306640625,
    height: 60,
    parentId: 'obj-car',
    data: {
      label: 'Assembled',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-car',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'state-installed',
    shape: 'opm-state',
    x: 82.23529411764707,
    y: 698.9411764705884,
    width: 80,
    height: 60,
    parentId: 'obj-engine',
    data: {
      label: 'Installed',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-engine',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'state-uninstalled',
    shape: 'opm-state',
    x: 186.23529411764707,
    y: 698.9411764705884,
    width: 88.12255859375,
    height: 60,
    parentId: 'obj-engine',
    data: {
      label: 'Uninstalled',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-engine',
      childStateCount: 0,
      selected: false,
      dragTarget: false,
    },
  },
  {
    id: 'obj-wheel',
    shape: 'opm-object',
    x: -336.4705882352941,
    y: 48.23529411764706,
    width: 140,
    height: 80,
    parentId: null,
    data: {
      label: 'Wheel',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'obj-door',
    shape: 'opm-object',
    x: -340,
    y: 207.0588235294117,
    width: 140,
    height: 80,
    parentId: null,
    data: {
      label: 'Door',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'obj-window',
    shape: 'opm-object',
    x: -337.64705882352945,
    y: 372.94117647058823,
    width: 140,
    height: 80,
    parentId: null,
    data: {
      label: 'Window',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'obj-seat',
    shape: 'opm-object',
    x: -331.764705882353,
    y: 534.1176470588234,
    width: 140,
    height: 80,
    parentId: null,
    data: {
      label: 'Seat',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'obj-frame',
    shape: 'opm-object',
    x: -337.64705882352945,
    y: 690.5882352941176,
    width: 140,
    height: 80,
    parentId: null,
    data: {
      label: 'Frame',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'obj-tire',
    shape: 'opm-object',
    x: -336.4705882352942,
    y: 832.9411764705882,
    width: 140,
    height: 80,
    parentId: null,
    data: {
      label: 'Tire',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'proc-assemble',
    shape: 'opm-process',
    x: 601.6666666666666,
    y: 289.26470588235287,
    width: 140,
    height: 100,
    parentId: null,
    data: {
      label: 'Assemble Car',
      type: 'process',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selectionMode: 'single',
      selected: false,
    },
  },
  {
    id: '9234c85c-6b41-41f5-bc98-68684b0c055a',
    shape: 'opm-object',
    x: 603.0637117273667,
    y: -256.03921172198136,
    width: 180,
    height: 80,
    parentId: null,
    data: {
      label: 'New Object',
      type: 'object',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
      dragTarget: false,
    },
  },
  {
    id: '41ee2290-cc90-425f-a54e-32ec8000814c',
    shape: 'opm-option',
    x: 233.6519272748162,
    y: 91.01960485121784,
    width: 180,
    height: 80,
    parentId: null,
    data: {
      label: '属性节点',
      type: 'option',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selectionMode: 'single',
      selected: false,
    },
  },
  {
    id: 'b5915929-39ed-4c30-b055-3b3f73664d7d',
    shape: 'opm-object',
    x: 1137.181339039522,
    y: 49.84313785328585,
    width: 180,
    height: 80,
    parentId: null,
    data: {
      label: 'New Object',
      type: 'object',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: 'b6e2da0b-b3c8-4070-b2fa-ecc2bbe7cc5e',
    shape: 'opm-object',
    x: 1139.5342586741729,
    y: -77.21568253461052,
    width: 180,
    height: 80,
    parentId: null,
    data: {
      label: 'New Object',
      type: 'object',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  {
    id: '9a4ba6d4-7c9e-4f8e-9163-a4c0ca05d787',
    shape: 'opm-object',
    x: 1143.0636417164524,
    y: 176.9019712560317,
    width: 180,
    height: 80,
    parentId: null,
    data: {
      label: 'New Object',
      type: 'object',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
      selected: false,
    },
  },
  // // === 对象 ===
  // {
  //   id: 'obj-car',
  //   shape: 'opm-object',
  //   x: 300,
  //   y: 80,
  //   width: 200,
  //   height: 222,
  //   data: {
  //     label: 'Car',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 2,
  //   },
  // },
  // // === 零部件集合目标节点 ===
  // {
  //   id: 'obj-parts-inventory',
  //   shape: 'opm-object',
  //   x: 1200,
  //   y: 660,
  //   width: 240,
  //   height: 110,
  //   data: {
  //     label: 'Parts Inventory',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-engine',
  //   shape: 'opm-object',
  //   x: 30,
  //   y: 340,
  //   width: 184,
  //   height: 206,
  //   data: {
  //     label: 'Engine',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 2,
  //   },
  // },
  // {
  //   id: 'obj-worker',
  //   shape: 'opm-object',
  //   x: 580,
  //   y: 340,
  //   width: 180,
  //   height: 90,
  //   data: {
  //     label: 'Worker',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-blueprint',
  //   shape: 'opm-object',
  //   x: 300,
  //   y: 580,
  //   width: 200,
  //   height: 80,
  //   data: {
  //     label: 'Assembly Blueprint',
  //     type: 'object',
  //     essence: 'informational',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },

  // // === 状态（Car 的子节点） ===
  // {
  //   id: 'state-unassembled',
  //   shape: 'opm-state',
  //   x: 316,
  //   y: 146,
  //   width: 80,
  //   height: 60,
  //   data: {
  //     label: 'Unassembled',
  //     type: 'state',
  //     essence: 'informational',
  //     active: false,
  //     executionState: 'idle',
  //     parentId: 'obj-car',
  //   },
  // },
  // {
  //   id: 'state-assembled',
  //   shape: 'opm-state',
  //   x: 404,
  //   y: 146,
  //   width: 80,
  //   height: 60,
  //   data: {
  //     label: 'Assembled',
  //     type: 'state',
  //     essence: 'informational',
  //     active: false,
  //     executionState: 'idle',
  //     parentId: 'obj-car',
  //   },
  // },

  // // === 状态（Engine 的子节点） ===
  // {
  //   id: 'state-installed',
  //   shape: 'opm-state',
  //   x: 42,
  //   y: 406,
  //   width: 80,
  //   height: 60,
  //   data: {
  //     label: 'Installed',
  //     type: 'state',
  //     essence: 'informational',
  //     active: false,
  //     executionState: 'idle',
  //     parentId: 'obj-engine',
  //   },
  // },
  // {
  //   id: 'state-uninstalled',
  //   shape: 'opm-state',
  //   x: 130,
  //   y: 406,
  //   width: 80,
  //   height: 60,
  //   data: {
  //     label: 'Uninstalled',
  //     type: 'state',
  //     essence: 'informational',
  //     active: false,
  //     executionState: 'idle',
  //     parentId: 'obj-engine',
  //   },
  // },
  // // === 零部件对象（独立关系组，仅与 Parts Inventory 关联） ===
  // {
  //   id: 'obj-wheel',
  //   shape: 'opm-object',
  //   x: 60,
  //   y: 780,
  //   width: 140,
  //   height: 80,
  //   data: {
  //     label: 'Wheel',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-door',
  //   shape: 'opm-object',
  //   x: 220,
  //   y: 780,
  //   width: 140,
  //   height: 80,
  //   data: {
  //     label: 'Door',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-window',
  //   shape: 'opm-object',
  //   x: 380,
  //   y: 780,
  //   width: 140,
  //   height: 80,
  //   data: {
  //     label: 'Window',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-seat',
  //   shape: 'opm-object',
  //   x: 540,
  //   y: 780,
  //   width: 140,
  //   height: 80,
  //   data: {
  //     label: 'Seat',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-frame',
  //   shape: 'opm-object',
  //   x: 700,
  //   y: 780,
  //   width: 140,
  //   height: 80,
  //   data: {
  //     label: 'Frame',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },
  // {
  //   id: 'obj-tire',
  //   shape: 'opm-object',
  //   x: 860,
  //   y: 780,
  //   width: 140,
  //   height: 80,
  //   data: {
  //     label: 'Tire',
  //     type: 'object',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //     childStateCount: 0,
  //   },
  // },

  // // === 过程 ===
  // {
  //   id: 'proc-assemble',
  //   shape: 'opm-process',
  //   x: 330,
  //   y: 280,
  //   width: 140,
  //   height: 100,
  //   data: {
  //     label: 'Assemble Car',
  //     type: 'process',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //   },
  // },
];

export const demoEdges = [
  {
    "id": "edge-gen-car",
    "shape": "opm-procedural-generation",
    "source": {
      "cell": "proc-assemble"
    },
    "target": {
      "cell": "obj-car"
    },
    "data": {
      "label": "generates",
      "edgeCategory": "procedural",
      "edgeSubtype": "generation",
      "flowIntensity": 1,
      "_originalConnector": {
        "name": "normal"
      },
      "_originalRouter": {
        "name": "normal"
      }
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 12 0 L 0 8 L 12 16 L 8 8 Z",
            "fill": "#ffffff",
            "stroke": "#595959",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "generates",
        "fill": "#595959",
        "fontSize": 11
      }
    },
    "vertices": []
  },
  {
    "id": "edge-consume-engine",
    "shape": "opm-procedural-consumption",
    "source": {
      "cell": "obj-engine"
    },
    "target": {
      "cell": "proc-assemble"
    },
    "data": {
      "label": "consumes",
      "edgeCategory": "procedural",
      "edgeSubtype": "consumption",
      "flowIntensity": 0.8,
      "_originalConnector": {
        "name": "normal"
      },
      "_originalRouter": {
        "name": "normal"
      }
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 12 0 L 0 8 L 12 16 L 8 8 Z",
            "fill": "#ffffff",
            "stroke": "#595959",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "consumes",
        "fill": "#595959",
        "fontSize": 11,
        "fontWeight": 500
      }
    },
    "vertices": []
  },
  {
    "id": "edge-effect-worker",
    "shape": "opm-procedural-effect",
    "source": {
      "cell": "obj-worker"
    },
    "target": {
      "cell": "proc-assemble"
    },
    "data": {
      "label": "affects",
      "edgeCategory": "procedural",
      "edgeSubtype": "effect",
      "flowIntensity": 0.6,
      "_originalConnector": {
        "name": "normal"
      },
      "_originalRouter": {
        "name": "normal"
      }
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 2,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 14 0 L 0 10 L 14 20 L 6 10 Z",
            "fill": "#595959",
            "stroke": "#595959",
            "strokeWidth": 1.5
          }
        },
        "sourceMarker": {
          "name": "path",
          "args": {
            "d": "M 14 0 L 0 10 L 14 20 L 8 10 Z",
            "fill": "#595959",
            "stroke": "#595959",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "affects",
        "fill": "#595959",
        "fontSize": 11
      }
    },
    "vertices": []
  },
  {
    "id": "edge-consume-blueprint",
    "shape": "opm-procedural-consumption",
    "source": {
      "cell": "obj-blueprint"
    },
    "target": {
      "cell": "proc-assemble"
    },
    "data": {
      "label": "consumes",
      "edgeCategory": "procedural",
      "edgeSubtype": "consumption",
      "flowIntensity": 0.5,
      "_originalConnector": {
        "name": "normal"
      },
      "_originalRouter": {
        "name": "normal"
      }
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 12 0 L 0 8 L 12 16 L 8 8 Z",
            "fill": "#ffffff",
            "stroke": "#595959",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "consumes",
        "fill": "#595959",
        "fontSize": 11,
        "fontWeight": 500
      }
    },
    "vertices": []
  },
  {
    "id": "edge-agg-wheel",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "obj-wheel"
    },
    "target": {
      "cell": "obj-parts-inventory",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "label": "participates",
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#8c8c8c",
        "strokeWidth": 1.5,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "participates",
        "fill": "#8c8c8c",
        "fontSize": 10
      }
    },
    "vertices": []
  },
  {
    "id": "edge-agg-door",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "obj-door"
    },
    "target": {
      "cell": "obj-parts-inventory",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "label": "participates",
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#8c8c8c",
        "strokeWidth": 1.5,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "participates",
        "fill": "#8c8c8c",
        "fontSize": 10
      }
    },
    "vertices": []
  },
  {
    "id": "edge-agg-window",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "obj-window"
    },
    "target": {
      "cell": "obj-parts-inventory",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "label": "participates",
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#8c8c8c",
        "strokeWidth": 1.5,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "participates",
        "fill": "#8c8c8c",
        "fontSize": 10
      }
    },
    "vertices": []
  },
  {
    "id": "edge-agg-seat",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "obj-seat"
    },
    "target": {
      "cell": "obj-parts-inventory",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "label": "participates",
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#8c8c8c",
        "strokeWidth": 1.5,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "participates",
        "fill": "#8c8c8c",
        "fontSize": 10
      }
    },
    "vertices": []
  },
  {
    "id": "edge-agg-frame",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "obj-frame"
    },
    "target": {
      "cell": "obj-parts-inventory",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "label": "participates",
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#8c8c8c",
        "strokeWidth": 1.5,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "participates",
        "fill": "#8c8c8c",
        "fontSize": 10
      }
    },
    "vertices": []
  },
  {
    "id": "edge-agg-tire",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "obj-tire"
    },
    "target": {
      "cell": "obj-parts-inventory",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "label": "participates",
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#8c8c8c",
        "strokeWidth": 1.5,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          }
        }
      },
      "label": {
        "text": "participates",
        "fill": "#8c8c8c",
        "fontSize": 10
      }
    },
    "vertices": []
  },
  {
    "id": "28f2253f-673d-49ba-9b87-02454426d67f",
    "shape": "opm-structural-aggregation",
    "source": {
      "cell": "41ee2290-cc90-425f-a54e-32ec8000814c",
      "port": "port-arrow",
      "anchor": {
        "name": "top"
      },
      "connectionPoint": {
        "name": "anchor"
      }
    },
    "target": {
      "cell": "9234c85c-6b41-41f5-bc98-68684b0c055a",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "edgeCategory": "structural",
      "edgeSubtype": "aggregation-participation",
      "label": "aggregation-participation",
      "isOptionArrowEdge": true,
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z",
            "fill": "none",
            "stroke": "#595959",
            "strokeWidth": 1.5
          }
        }
      }
    },
    "vertices": [
      {
        "x": 323.6519272748162,
        "y": 59.019604851217835
      },
      {
        "x": 693.0637117273667,
        "y": 59.019604851217835
      }
    ]
  },
  {
    "id": "beef5638-cbc3-4c10-9b34-99deb135ccd0",
    "shape": "opm-structural-exhibition",
    "source": {
      "cell": "b5915929-39ed-4c30-b055-3b3f73664d7d"
    },
    "target": {
      "cell": "9234c85c-6b41-41f5-bc98-68684b0c055a",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "edgeCategory": "structural",
      "edgeSubtype": "exhibition-characterization",
      "label": "展示特征",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z M 4 8 L 12 4 L 12 12 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          },
          "stroke": "#595959",
          "fill": "none"
        }
      },
      "label": {
        "text": "展示特征",
        "fill": "#595959",
        "fontSize": 11
      }
    },
    "vertices": []
  },
  {
    "id": "82a094c0-9ef9-4cf7-bf4c-5eb2f25297ec",
    "shape": "opm-structural-exhibition",
    "source": {
      "cell": "b6e2da0b-b3c8-4070-b2fa-ecc2bbe7cc5e"
    },
    "target": {
      "cell": "9234c85c-6b41-41f5-bc98-68684b0c055a",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "edgeCategory": "structural",
      "edgeSubtype": "exhibition-characterization",
      "label": "展示特征",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z M 4 8 L 12 4 L 12 12 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          },
          "stroke": "#595959",
          "fill": "none"
        }
      },
      "label": {
        "text": "展示特征",
        "fill": "#595959",
        "fontSize": 11
      }
    },
    "vertices": []
  },
  {
    "id": "6bd45909-32f3-4a14-9750-3ca3f9411e7b",
    "shape": "opm-structural-exhibition",
    "source": {
      "cell": "9a4ba6d4-7c9e-4f8e-9163-a4c0ca05d787"
    },
    "target": {
      "cell": "9234c85c-6b41-41f5-bc98-68684b0c055a",
      "connectionPoint": {
        "name": "boundary"
      }
    },
    "data": {
      "edgeCategory": "structural",
      "edgeSubtype": "exhibition-characterization",
      "label": "展示特征",
      "_originalConnector": {
        "name": "jumpover",
        "args": {
          "size": 5
        }
      },
      "_originalRouter": {
        "name": "orth",
        "args": {
          "padding": 20
        }
      },
      "_mergedEdge": true
    },
    "attrs": {
      "lines": {
        "connection": true,
        "strokeLinejoin": "round"
      },
      "wrap": {
        "strokeWidth": 10
      },
      "line": {
        "stroke": "#595959",
        "strokeWidth": 1.8,
        "targetMarker": {
          "name": "path",
          "args": {
            "d": "M 0 8 L 14 0 L 14 16 Z M 4 8 L 12 4 L 12 12 Z",
            "fill": "none",
            "stroke": "#8c8c8c",
            "strokeWidth": 1.5
          },
          "stroke": "#595959",
          "fill": "none"
        }
      },
      "label": {
        "text": "展示特征",
        "fill": "#595959",
        "fontSize": 11
      }
    },
    "vertices": []
  }
  // // === 过程性关系：生成 ===
  // {
  //   id: 'edge-gen-car',
  //   shape: 'opm-procedural-generation',
  //   source: { cell: 'proc-assemble' },
  //   target: { cell: 'obj-car' },
  //   data: {
  //     label: 'generates',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'generation',
  //     flowIntensity: 1.0,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'generates',
  //       fill: '#595959',
  //       fontSize: 11,
  //     },
  //   },
  // },

  // // === 过程性关系：消耗（Engine → Assemble） ===
  // {
  //   id: 'edge-consume-engine',
  //   shape: 'opm-procedural-consumption',
  //   source: { cell: 'obj-engine' },
  //   target: { cell: 'proc-assemble' },
  //   data: {
  //     label: 'consumes',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'consumption',
  //     flowIntensity: 0.8,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'consumes',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontWeight: 500,
  //     },
  //   },
  // },

  // // === 过程性关系：影响（Worker → Assemble） ===
  // {
  //   id: 'edge-effect-worker',
  //   shape: 'opm-procedural-effect',
  //   source: { cell: 'obj-worker' },
  //   target: { cell: 'proc-assemble' },
  //   data: {
  //     label: 'affects',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'effect',
  //     flowIntensity: 0.6,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'affects',
  //       fill: '#595959',
  //       fontSize: 11,
  //     },
  //   },
  // },

  // // === 过程性关系：消耗（Blueprint → Assemble） ===
  // {
  //   id: 'edge-consume-blueprint',
  //   shape: 'opm-procedural-consumption',
  //   source: { cell: 'obj-blueprint' },
  //   target: { cell: 'proc-assemble' },
  //   data: {
  //     label: 'consumes',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'consumption',
  //     flowIntensity: 0.5,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'consumes',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontWeight: 500,
  //     },
  //   },
  // },

  // // === 结构性关系：聚合（6个零部件 → Parts Inventory，同类型边合并展示） ===
  // {
  //   id: 'edge-agg-wheel',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-wheel' },
  //   target: { cell: 'obj-parts-inventory' },
  //   data: {
  //     label: 'participates',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },
  // {
  //   id: 'edge-agg-door',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-door' },
  //   target: { cell: 'obj-parts-inventory' },
  //   data: {
  //     label: 'participates',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },
  // {
  //   id: 'edge-agg-window',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-window' },
  //   target: { cell: 'obj-parts-inventory' },
  //   data: {
  //     label: 'participates',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },
  // {
  //   id: 'edge-agg-seat',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-seat' },
  //   target: { cell: 'obj-parts-inventory' },
  //   data: {
  //     label: 'participates',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },
  // {
  //   id: 'edge-agg-frame',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-frame' },
  //   target: { cell: 'obj-parts-inventory' },
  //   data: {
  //     label: 'participates',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },
  // {
  //   id: 'edge-agg-tire',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-tire' },
  //   target: { cell: 'obj-parts-inventory' },
  //   data: {
  //     label: 'participates',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },
];
